var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.showopenmodal
        ? _c(
            "div",
            [
              _c("transition", { attrs: { name: "modal" } }, [
                _c("div", { staticClass: "modal-mask" }, [
                  _c("div", { staticClass: "modal-wrapper" }, [
                    _c(
                      "div",
                      {
                        staticClass: "modal-dialog modal-md",
                        staticStyle: { display: "block !important" },
                      },
                      [
                        _c("div", { staticClass: "modal-content" }, [
                          _c("div", { staticClass: "modal-header pb-0" }, [
                            _c(
                              "h5",
                              {
                                staticClass:
                                  "modal-title text-center pull-left w-100 d-block mt-4 pb-0",
                              },
                              [
                                _vm._v(
                                  "\n                                    Time Format Settings\n                                "
                                ),
                              ]
                            ),
                            _c(
                              "button",
                              {
                                staticClass: "close",
                                attrs: {
                                  type: "button",
                                  "data-dismiss": "modal",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.cancelAction()
                                  },
                                },
                              },
                              [
                                _c("i", { staticClass: "material-icons" }, [
                                  _vm._v("close"),
                                ]),
                              ]
                            ),
                          ]),
                          _c("div", { staticClass: "modal-body p-0" }, [
                            _c("div", [
                              _vm.showspinner
                                ? _c(
                                    "div",
                                    { staticClass: "appointmentlist-spinner" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "processing_popup full-spinner",
                                          staticStyle: {
                                            visibility: "visible",
                                            top: "-68px",
                                            height: "261px",
                                            "z-index": "9999999999",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "spinner cover-spin",
                                            },
                                            [
                                              _c("div", {
                                                staticClass: "bounce1",
                                              }),
                                              _c("div", {
                                                staticClass: "bounce2",
                                              }),
                                              _c("div", {
                                                staticClass: "bounce3",
                                              }),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _c(
                                "div",
                                { staticClass: "pl-3 pr-3 pb-3 pt-3" },
                                [
                                  _c(
                                    "label",
                                    {
                                      staticClass: "radio-container",
                                      staticStyle: { width: "40% !important" },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                            12-Hour\n                                            "
                                      ),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.selectedTimeFormat,
                                            expression: "selectedTimeFormat",
                                          },
                                        ],
                                        attrs: {
                                          name: "timeformat",
                                          type: "radio",
                                          value: "12hr",
                                        },
                                        domProps: {
                                          checked: _vm._q(
                                            _vm.selectedTimeFormat,
                                            "12hr"
                                          ),
                                        },
                                        on: {
                                          change: function ($event) {
                                            _vm.selectedTimeFormat = "12hr"
                                          },
                                        },
                                      }),
                                      _c("span", {
                                        staticClass: "radio-checkmark",
                                      }),
                                    ]
                                  ),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "radio-container",
                                      staticStyle: { width: "50% !important" },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                            24-Hour\n                                            "
                                      ),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.selectedTimeFormat,
                                            expression: "selectedTimeFormat",
                                          },
                                        ],
                                        attrs: {
                                          name: "timeformat",
                                          type: "radio",
                                          value: "24hr",
                                        },
                                        domProps: {
                                          checked: _vm._q(
                                            _vm.selectedTimeFormat,
                                            "24hr"
                                          ),
                                        },
                                        on: {
                                          change: function ($event) {
                                            _vm.selectedTimeFormat = "24hr"
                                          },
                                        },
                                      }),
                                      _c("span", {
                                        staticClass: "radio-checkmark",
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                              _c(
                                "div",
                                { staticClass: "col-md-12 mb-3 mt-3" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "time-preview-box p-3 rounded bg-light text-center",
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "preview-label d-block mb-1",
                                        },
                                        [_vm._v("Preview")]
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "preview-time" },
                                        [_vm._v(_vm._s(_vm.previewTime))]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "pull-left mb-4 pl-5 pr-5 col-md-12 mt-2",
                                },
                                [
                                  _vm._t("footer", function () {
                                    return [
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "secondary-btn ripple pull-left",
                                          attrs: { type: "button" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.resetSetting()
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                                Reset\n                                            "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "primary-btn ripple pull-right",
                                          attrs: { type: "button" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.saveSettings()
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                                Save\n                                            "
                                          ),
                                        ]
                                      ),
                                    ]
                                  }),
                                ],
                                2
                              ),
                            ]),
                          ]),
                        ]),
                      ]
                    ),
                  ]),
                ]),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm.isdisplaymsg
        ? _c("Messages", {
            attrs: {
              datamessage: _vm.sucessmsgtext,
              iserror: _vm.iserrormsg,
              isVisible: _vm.isdisplaymsg,
            },
            on: { closemsg: _vm.closeMessage },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }